import { action, observable } from 'mobx';

import { BusyStore } from 'ui/base/button';
import { BooleanStore } from 'ui/base/input';
import { ModalStore } from 'ui/base/modal/modal_store';

import { ResultKind } from 'services/base/types';
import { IAccountsDomain, Pangolin } from 'services/accounts/types';
import * as PangolinService from 'services/accounts/pangolin_service';

export class ScannerTuningStore {
  private readonly pangolin: Pangolin;

  enableScanMdns: BooleanStore;
  enableScanNbios: BooleanStore;
  enableScanNmap: BooleanStore;
  enableScanRdns: BooleanStore;
  enableScanUpnp: BooleanStore;

  enableScanMdnsModal: ModalStore;
  enableScanNbiosModal: ModalStore;
  enableScanNmapModal: ModalStore;
  enableScanRdnsModal: ModalStore;
  enableScanUpnpModal: ModalStore;

  @observable.ref
  busy: BusyStore;

  constructor(pangolin: Pangolin) {
    this.pangolin = pangolin;

    this.enableScanMdns = new BooleanStore(pangolin.scannerEnableScanMdns);
    this.enableScanNbios = new BooleanStore(pangolin.scannerEnableScanNbios);
    this.enableScanNmap = new BooleanStore(pangolin.scannerEnableScanNmap);
    this.enableScanRdns = new BooleanStore(pangolin.scannerEnableScanRdns);
    this.enableScanUpnp = new BooleanStore(pangolin.scannerEnableScanUpnp);

    this.enableScanMdnsModal = new ModalStore(false);
    this.enableScanNbiosModal = new ModalStore(false);
    this.enableScanNmapModal = new ModalStore(false);
    this.enableScanRdnsModal = new ModalStore(false);
    this.enableScanUpnpModal = new ModalStore(false);

    this.busy = new BusyStore();
  }

  @action.bound
  async handleSave(accounts: IAccountsDomain): Promise<PangolinService.UpdatePangolinResult> {
    if (accounts.pangolins.has(this.pangolin.id)) {
      return await PangolinService.update({
        domain: accounts, id: this.pangolin.id,
        scannerEnableScanMdns: this.enableScanMdns.value,
        scannerEnableScanNbios: this.enableScanNbios.value,
        scannerEnableScanNmap: this.enableScanNmap.value,
        scannerEnableScanRdns: this.enableScanRdns.value,
        scannerEnableScanUpnp: this.enableScanUpnp.value,
      });
    }

    return { kind: ResultKind.SYSTEM_ERROR };
  }
}